export enum ContactColumnEnum {
    CONTACT_ATTN = 'CONTACT_ATTN',
    CONTACT_ORGANIZATION = 'CONTACT_ORGANIZATION',
    CONTACT_STREET1 = 'CONTACT_STREET1',
    CONTACT_STREET2 = 'CONTACT_STREET2',
    CONTACT_STREET3 = 'CONTACT_STREET3',
    CONTACT_CITY = 'CONTACT_CITY',
    CONTACT_PROVINCE = 'CONTACT_PROVINCE',
    CONTACT_COUNTRY = 'CONTACT_COUNTRY',
    CONTACT_POSTALCODE = 'CONTACT_POSTALCODE',
    CONTACT_TEL = 'CONTACT_TEL',
    CONTACT_EMAIL = 'CONTACT_READONLY',
    CONTACT_ADDRESS_BOOK = 'CONTACT_ADDRESS_BOOK',
    CONTACT_REFERENCE = 'CONTACT_REFERENCE'
}
